/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_Open_Application_MessageInputs */

const en_register_onboarding_personal_info_open_application_message = /** @type {(inputs: Register_Onboarding_Personal_Info_Open_Application_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You already have an open application. While it is in progress, you cannot change your resume data.`)
};

const de_register_onboarding_personal_info_open_application_message = /** @type {(inputs: Register_Onboarding_Personal_Info_Open_Application_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast bereits eine offene Bewerbung. Solange sie in Bearbeitung ist, kannst du deine Lebenslaufdaten nicht ändern.`)
};

/**
* | output |
* | --- |
* | "You already have an open application. While it is in progress, you cannot change your resume data." |
*
* @param {Register_Onboarding_Personal_Info_Open_Application_MessageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_open_application_message = /** @type {((inputs?: Register_Onboarding_Personal_Info_Open_Application_MessageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_Open_Application_MessageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_open_application_message(inputs)
	return en_register_onboarding_personal_info_open_application_message(inputs)
});